export const name = 'ExperimentAspect'

export const functionLibrary = {
    isExperimentOpen: (runningExperiments, experimentName) => {
        const value = runningExperiments[experimentName] || runningExperiments[experimentName.toLowerCase()]
        return !!(value && value !== 'old' && value !== 'false')
    }
}
